import React, { useContext, useState } from 'react';
import styles from './ScanQrChecker.module.css'; 
import { useHistory } from 'react-router-dom';
import { WelletContext } from '../../context/WelletContext';
import { useLocation } from 'react-router-dom';
import { SuccessIcon } from '../icons/successIcon';
import { useTranslation } from 'react-i18next';


const ManualQrCheckerExit = (props) => {
    const history = useHistory();
    const welletContext = useContext(WelletContext);
    const location = useLocation();
    const { t } = useTranslation();
    const queryParams = new URLSearchParams(location.search);
    const referenceCode = queryParams.get('referenceCode');
    const codeTicket = queryParams.get('codeTicket');
    const showName = queryParams.get('showName');
    const idShow = queryParams.get('id');
    const checkin = async () => {
      try {
        const result = await welletContext.apis.tickets.post(
          `/api/checkin/CheckInTicket?check=${true}`,
          {
            ReferenceCode: referenceCode,
          Token: null,
          EventId: idShow,
          DeviceId: null,
          },
        ); 
      } catch (error) {
        console.error(error);
        history.push('/qr-scan-error');
      }
    };

    const handleCheckIn = async () => {
      await checkin();
      history.push(`/check-in-show?codeTicket=${encodeURIComponent(codeTicket)}&id=${encodeURIComponent(idShow)}&showName=${encodeURIComponent(showName)}`); 
    };

    return (
      <div className={styles.paymentExit}>
        <div className={styles.successIcon}>
          <div className={styles.circle}>
            <SuccessIcon size={'110px'} color={'#FFF'} />
          </div>
        </div>
        <div className='container mx-1'>
          <div className={`font-large bold mt-4 ${styles.validTitle}`}>{t('checkShow.valid')}</div>
          <div className='font-medium mt-3 lh-title'>e-ticket {t('checkShow.validTicket')}</div>
          <div className='mt-4'>
            <div>
              <div className='font-tiny'>Ticket</div>
              <div className={`d-flex justify-content-between align-items-center ${styles.containerBorder}`}>
                <div className='font-normal bold'>{showName}</div>
              </div>
            </div>
            {/* <div className={`pt-2 d-flex ${styles.containerBorder}`}>
              <div className='col pl-0'>
                <div className='font-tiny'>Gate/Section</div>
                <div className='font-normal bold'>Puerta 2</div>
              </div>
              <div className='col-auto text-center pl-0'>
                <div className='font-tiny'>Row</div>
                <div className='font-normal bold'>1</div>
              </div>
              <div className='col-auto text-center pl-4 pr-4'>
                <div className='font-tiny'>Seat</div>
                <div className='font-normal bold'>2</div>
              </div>
            </div> */}
          </div>
          <div className='mt-2 font-tiny'>ID TICKET </div>
          <div className='font-tiny'>#{codeTicket}</div>
          <div className='d-flex justify-content-end pt-4 pb-5'>
            <div
              className={`font-normal bold ${styles.button} ${styles.buttonBorderValid}`}
              onClick={handleCheckIn}
            >
              Check-In
            </div>
          </div>
        </div>
      </div>
    );
};

export default ManualQrCheckerExit;
